import { delay } from 'pano-utils';
import { combine, guard } from 'effector';
import { showConfirmModal } from '@components/ConfirmModal';
import {
  $editingHotspot,
  $editingHotspotApi,
} from '@stores/editingHotspotStores';
import { $curScene } from '@stores/dataStores';
import {
  $GateHotspotBatchMode,
  $GateHotspotGroupMode,
  $gateHotspotLayerMode,
} from '@stores/hotspotStores';
import krpAddHotspot from './krpAddHotspot';
import krpRemoveHotspot from './krpRemoveHotspot';
import toggleHotspotSelected from './toggleHotspotSelected';
import domain from '../domain';

const onHotspotClick = domain.event<{ id: string }>();

const $isClickOn = combine(
  $GateHotspotBatchMode.state,
  $GateHotspotGroupMode.state,
  $gateHotspotLayerMode.state,
  (batch, group, layer) => !batch && !group && !layer
);

guard({
  clock: onHotspotClick,
  filter: $isClickOn,
}).watch(async ({ id }) => {
  const scene = $curScene.getState()!;
  const hotspot = scene?.hotspot?.find((x) => x.id === id);
  if (!hotspot) return;
  const editing = $editingHotspot.getState();
  const editingId = editing?.hotspot.id;
  if (id === editingId) return;
  if (editingId) {
    const oldData = scene?.hotspot?.find((x) => x.id === editingId)!;
    if (editing?.hotspot !== oldData || editing?.isNew) {
      const { confirmed } = await showConfirmModal({
        title: '有未保存的更改',
        content: '当前所有未经保存的改动将丢失, 是否继续?',
      });
      if (!confirmed) return;
      krpRemoveHotspot(editingId);
      if (oldData && !editing?.isNew) {
        krpAddHotspot(oldData);
      }
    }
    $editingHotspotApi.set(null);
    await delay(100);
  }
  $editingHotspotApi.set({
    hotspot,
    sceneId: scene.id,
    sceneType: scene.type,
  });
  toggleHotspotSelected({
    id: hotspot.id,
    isOn: true,
  });
});

export default onHotspotClick;
